module.exports = __webpack_public_path__ + "static/media/Armenia.b15c01a0.png";